import { observable, runInAction } from 'mobx';
import * as React from 'react';
import { ISubmenuArray } from '../comps/Submenu';

//TODO drop the whole file

const myContext = React.createContext<ISubmenuArray | undefined>(undefined);

/** @deprecated */
export const SubmenuProvider = ({children} : {children: React.ReactNode}) => {
	const array = observable.array([], {deep: false});
	return <myContext.Provider value={array}>{children}</myContext.Provider>;
};

function setSubmenuNow(dst: ISubmenuArray, src: ISubmenuArray) {
	const len = src.length;
	if (dst.length !== len) dst.length = len;
	for (let i=0; i<len; ++i) {
		if (dst[i] !== src[i]) dst[i] = src[i];
	}
}

function setSubmenu(dst: ISubmenuArray, src: ISubmenuArray) {
	setTimeout(() => {
		runInAction(() => setSubmenuNow(dst, src));
	}, 0);
}

/** @deprecated */
export const useSubmenu = (newValue?: ISubmenuArray) => {
	const result = React.useContext(myContext);
	if (!result) throw new Error('Missing submenu.');
	if (newValue && newValue!==result) setSubmenu(result, newValue);
	return result;
};

/** @deprecated Use only temporarily.*/
export const useNoSubmenu = () => {
	useSubmenu([]);
};
